import { funnelData } from "@/mocks/reportsData";

export default function ConversionFunnel({ onExport }: { onExport?: () => void }) {
  return (
    <div className="bg-white rounded-xl border border-gray-200 p-5">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-semibold text-gray-900">Conversion Funnel</h3>
        {onExport && (
          <button
            onClick={onExport}
            className="w-8 h-8 flex items-center justify-center rounded-lg text-gray-400 hover:text-indigo-600 hover:bg-indigo-50 transition-colors cursor-pointer"
            title="Export CSV"
          >
            <i className="ri-download-line text-sm" />
          </button>
        )}
      </div>
      <div className="space-y-2">
        {funnelData.map((item, idx) => {
          const barWidth = (item.percentage / 100) * 80;
          const isLast = idx === funnelData.length - 1;
          const dropOff = idx > 0 ? funnelData[idx - 1].percentage - item.percentage : 0;

          return (
            <div key={item.stage} className="flex items-center gap-3">
              <span className="w-[100px] text-xs text-gray-600 flex-shrink-0 whitespace-nowrap">{item.stage}</span>
              <div className="flex-1 min-w-0 flex items-center">
                <div
                  className={`h-7 ${item.color} rounded flex items-center justify-end pr-2.5 transition-all duration-500`}
                  style={{ width: `${Math.max(barWidth, 4)}%` }}
                >
                  {barWidth > 12 && (
                    <span className="text-xs font-semibold text-white">{item.count}</span>
                  )}
                </div>
                {barWidth <= 12 && (
                  <span className="text-xs font-semibold text-gray-700 ml-2">{item.count}</span>
                )}
              </div>
              <span className="text-xs text-gray-500 flex-shrink-0 w-[50px] text-right whitespace-nowrap">{item.percentage}%</span>
              {!isLast && idx > 0 && (
                <span className="text-[10px] text-red-500 flex-shrink-0 w-[55px] text-right whitespace-nowrap">
                  -{dropOff}%
                </span>
              )}
              {idx === 0 && <span className="w-[55px] flex-shrink-0" />}
            </div>
          );
        })}
      </div>
    </div>
  );
}